/**
 * SG — Change of Registered Office Address (B32105) Register Detail 매핑.
 *
 * 이파일링 완료 후 TaskListPage 의 Register 버튼 클릭 시
 * TASK_DATA.formData 에서 주소 정보를 추출해 요약 표시.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

function trim(value: unknown): string {
  return value === null || value === undefined ? '' : String(value).trim();
}

function buildAddressOneLine(source: Record<string, any>): string {
  const addr = source?.officeAddr || source;
  const blockNo = trim(addr?.blkHseNo || addr?.blkhseNo || addr?.blockNo);
  const streetName = trim(addr?.streetName);
  const buildingName = trim(addr?.buildingName);
  const level = trim(addr?.levelNo || addr?.addrLevel);
  const unit = trim(addr?.unitNo || addr?.addrUnit);
  const postalCode = trim(addr?.postalCode);

  let address = blockNo;
  if (streetName) address += (address ? ' ' : '') + streetName;
  if (level) address += (address ? ' #' : '#') + level;
  if (unit) address += (address ? '-' : '') + unit;
  if (buildingName) address += (address ? ' ' : '') + buildingName;
  if (postalCode) address += (address ? ' Singapore ' : 'Singapore ') + postalCode;
  return address.trim();
}

registerRegisterDetail('B32105', {
  title: 'Change of Registered Office Address',
  fields: [
    {
      label: 'New Registered Office Address',
      key: ['newOfficeAddress', 'new_office_address', 'officeAddr'],
      format: (raw: any, source?: Record<string, any>) => {
        if (typeof raw === 'string' && raw.trim()) return raw;
        return buildAddressOneLine(source || {});
      },
    },
    { label: 'Postal Code', key: ['officeAddr.postalCode'] },
    { label: 'Block / House No.', key: ['officeAddr.blkHseNo', 'officeAddr.blkhseNo'] },
    { label: 'Street Name', key: ['officeAddr.streetName'] },
    { label: 'Building Name', key: ['officeAddr.buildingName'] },
    { label: 'Level', key: ['officeAddr.levelNo'] },
    { label: 'Unit', key: ['officeAddr.unitNo'] },
    {
      label: 'Effective Date of Change',
      key: ['dated', 'effectiveDateOfChange', 'addressEffectiveDate'],
    },
  ],
});
